import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React from "react";
import classnames from "classnames";
import config from "../../config";
import styles from "./EstateLabel.module.scss";
export var EstateLabel = function EstateLabel(a) {
  var b = a.estate,
      c = void 0 === b ? {} : b,
      d = a.builder,
      e = void 0 === d ? {} : d,
      f = a.neighbourhood,
      g = void 0 === f ? {} : f,
      h = a.className,
      i = a.style,
      j = void 0 === i ? {} : i,
      k = _objectWithoutProperties(a, ["estate", "builder", "neighbourhood", "className", "style"]),
      l = !config.api.get("project") && !config.api.get("neighbourhood"),
      m = config.api.get("project"),
      n = l ? c.logo : m ? g.logo : null,
      o = l ? c.label : m ? g.label : null,
      p = l ? c.color : m ? g.color : null,
      q = e.logo ? /*#__PURE__*/React.createElement("img", {
    src: e.logo,
    alt: e.name,
    width: "100px",
    className: classnames("ta-builder-logo", styles.builder)
  }) : null;

  return n ? /*#__PURE__*/React.createElement("div", Object.assign({}, k, {
    className: classnames(styles.wrapper, h),
    style: _objectSpread({}, j, {
      backgroundColor: p
    })
  }), /*#__PURE__*/React.createElement("img", {
    src: n,
    alt: o,
    className: styles.logo
  }), q) : e.logo ? q : null;
};
export default EstateLabel;